__turbopack_context__.v({
  "art": "YrditG_art",
  "cardBody": "YrditG_cardBody",
  "cardLabel": "YrditG_cardLabel",
  "cardTitle": "YrditG_cardTitle",
  "carousel": "YrditG_carousel",
  "copy": "YrditG_copy",
  "edge": "YrditG_edge",
  "section": "YrditG_section",
  "shade": "YrditG_shade",
  "stage": "YrditG_stage",
});
